<template>
  <div class="wrap">
    <div class="prolist">
      <div class="left_menu">
        <div class="left_menu_bottom">
          <dl class="left_menu_bottom_dl1">
            <dt><img src="../../assets/images/list_03.jpg" alt="">人气排行</dt>
            <dd>
              <ul>
                <li class="left_menu_bottom_dl1_li clearfix" @click="getDetail(item.goodsTypeId,item.id)"  v-for="item in topNumList" :key="item.id">
                  <img :src="item.img" :title="item.name" :alt="item.name">
                  <a class="left_menu_bottom_dl1_dd">
                    <p>{{item.name}}</p>
                    <p>兑换积分：<span style="color: rgb(188, 5, 3); font-size: 12px; font-weight: 800;">{{item.score}}</span></p>
                  </a>
                </li>
              </ul>
            </dd>
          </dl>
        </div>

      </div>
      <ul class="prolist_ul">
        <li v-for="item in listData.records" :key = item.id @click="getDetail(item.goodsTypeId,item.id)">
          <a><img :src="item.img" :title="item.name" :alt="item.name"></a>
          <h2><a>{{item.name}}</a></h2>
          <p><span style="color:#BC0503;font-size:24px;font-weight: 800">{{item.score}}</span>积分</p>
        </li>
      </ul>
      <p v-if="listData.records && !listData.records.length" class="prolist_tips">亲爱的会员，您输入的关键字或积分没有相关商品，请检查！！！</p>
    </div>
    <div class="page">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :page-size="listData.size"
        layout="total, prev, pager, next"
        :total="listData.total">
      </el-pagination>
    </div>
    <div v-if="isShowbtn" class="returntop" @click="backtop"> TOP </div>
  </div>
</template>

<script>
import {
  getGoodsList,
  getTopNumList
} from "@/api/api";
import MinXin from '@/components/mixins'

  export default {
    name: 'searchList',
    mixins: [MinXin],
    data() {
      return {
        typeId: "",
        listData: {}, // 礼品列表集合
        topNumList:[], // 排行榜
      }
    },
    watch: {
       $route(){
        console.log(this.$route.query)
        const params = this.$route.query;
        const data = {
          'pageCurrent': 1,
          'pageSize': 16,
          ...params
        };
        this.getGoodsList(data);
        }
    },
    methods: {
      getGoodsList(data) {
        getGoodsList(data).then(res => {
          this.listData = res.data.data;
        })
      },
      getTopNumList(){
        getTopNumList(5).then(res => {
          if(res.data.code === 0){
            this.topNumList = res.data.data;
          }
        })
      },
      handleCurrentChange(e) {
        const params = this.$route.query;
        const data = {
          'pageCurrent': e,
          'pageSize': 16,
          ...params
        };
        this.getGoodsList(data);
      }
    },
    mounted() {
      const params = this.$route.query;
      const data = {
        'pageCurrent': 1,
        'pageSize': 16,
         ...params
      };
      this.getGoodsList(data);
      this.getTopNumList();
    }
  }
</script>

<style scoped>
  .wrap{ width: 1000px; margin: 0 auto}
  dd {-webkit-margin-start:0px;}
  dl{-webkit-margin-before: 0em;-webkit-margin-after: 0em;-webkit-margin-start: 0px;-webkit-margin-end: 0px;}
  h2 {font-weight: 100 !important;}
  /* 中间banner */
  .centerBanner{ overflow: hidden; font-size: 0;width: 1000px}
  .centerBanner img{width: 100%}
  .prolist{ padding: 12px 0 0; overflow: hidden;}
  .prolist_ul{overflow: hidden;}
  .prolist_ul ul{ width: 818px;float: right;overflow: hidden;}
  .prolist_ul li{ float: left; width: 150px; padding: 12px 17px; text-align: center; border: 1px solid #999; margin: 0 0 12px 18px; overflow: hidden}
  .prolist_ul li img{ width: 150px; height: 150px;}
  .prolist_ul li h2,
  .prolist_ul li p{ font-size: 14px; padding: 0 0 0; color: #000; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;}
  .prolist_ul li a{font-size: 17px;}
  .prolist_ul li a:hover img{ transform:scale(1.1);  }
  .prolist_ul li a:link {color: #000000}		/* 未访问的链接 */
  .prolist_ul li a:visited {color: gray}	/* 已访问的链接 */
  .prolist_ul li a:hover {color: #464646}	/* 鼠标移动到链接上 */
  .prolist_ul li a:active {color: #0000FF}	/* 选定的链接 */
  .prolist_tips{text-align: center;color: red}

  /* 排序 */
  .sort{ background: #dbdbdb; padding: 0 10px; text-align: right; color: #666; line-height: 30px; font-size: 14px;}
  .sort select{ line-height: 26px; margin: 2px 0 2px 6px; height: 26px; width: 100px;}

  /* 分页 */
  .page{ text-align: center; display: block; overflow: hidden; width: 100%; padding: 30px 0 50px}
  .page a{ display: inline-block; vertical-align: middle; margin: 0 5px; width: 30px; height: 30px; line-height: 30px; text-align: center; font-size: 14px; border: 1px solid #ccc; border-radius: 5px;}
  .page a.firstPage{ width: 60px;}
  .page a.prevPage{ width: 60px;}
  .page a.nextPage{ width: 60px;}
  .page a.lastPage{ width: 70px;}
  .page a.cur,
  .page a:hover{ background: #000; color: #fff}
  .page span{ margin-left: 10px; font-size: 14px; color: #999}

  /*左边菜单*/
  dl,dd,dt{margin: 0}
  .left_menu{width: 180px;float: left;}
  .left_menu_top{text-align: left;margin-bottom:16px}
  .left_menu_top_dl1{border: 1px solid #dddddd}
  .left_menu_top dl dt img{margin-bottom: -5px;margin-left: 5px;margin-right: 5px;}
  .left_menu_top dl dt{height: 30px;line-height: 30px;background-color: #ebebeb}
  .left_menu_top_lable1{color: #929292;font-size: 0.8rem}
  .left_menu_top_input1{width: 110px}
  .left_menu_top_input2{width: 40px}
  .left_menu_top_dl button{border: none;background-color: #000000;color: #ffffff;padding: 5px;cursor: pointer}
  .left_menu_top_dl{width: 95%;margin: 20px auto;overflow: auto}
  .left_menu_top_dl dd{margin-bottom: 1rem; }
  .left_menu_top_dl dd:nth-child(1){text-align: right}
  .left_menu_top_dl dd:nth-child(2){text-align: left}
  .left_menu_top_dl dd:nth-child(3){text-align: center}
  .left_menu_middle{text-align: left;border: 1px solid #dddddd;overflow: hidden;margin-bottom: 1rem;}
  .left_menu_middle_dl1{border: 1px solid #dddddd;padding-bottom: 20px;}
  .left_menu_middle dl dt{height: 30px;line-height: 30px;background-color: #ebebeb}
  .left_menu_middle dl dt img{margin-bottom: -5px;margin-left: 5px;margin-right: 5px;}
  .left_menu_middle_dl1 dd ul{width: 180px;padding-top: 0.5rem;}
  .left_menu_middle_dl1 dd ul li{margin: 0;border: none;text-align:left;font-size: 14px;padding: 10px 0 5px 10px;color: gray;cursor: pointer }
  .left_menu_middle_dl1_icon{display: inline-block;width: 0;height: 0;border-top: 5px solid transparent;border-left: 10px solid gray;border-bottom: 5px solid transparent;}
  .left_menu_bottom{text-align: left;border: 1px solid #dddddd  ;overflow: hidden;}
  .left_menu_bottom_dl1{border: 1px solid #dddddd}
  .left_menu_bottom dl dt{height: 30px;line-height: 30px;background-color: #ebebeb}
  .left_menu_bottom dl dt img{margin-bottom: -5px;margin-left: 5px;margin-right: 5px;}
  .left_menu_bottom_dl1 dd ul{width: 175px}
  .left_menu_bottom_dl1_img{width: 90px;}
  .left_menu_bottom_dl1_li img{width:50px ;height:50px;float: left;border: 1px solid #dddddd;margin-right: 5px}
  .left_menu_bottom_dl1_li{margin: 0!important;width: 100%!important;border-bottom: 1px solid #999!important;padding:16px 10px;}
  .left_menu_bottom_dl1_dd{float: left;width: 100px;height: 50px;}
  .left_menu_bottom_dl1_dd p{ -webkit-margin-before: 0em; -webkit-margin-after: 0em; -webkit-margin-start: 0px;-webkit-margin-end: 0px;font-size: 12px;color: gray;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;margin: 0}
  .left_menu_bottom_dl1_dd p:nth-child(1){line-height: 20px}
  .left_menu_bottom_dl1_dd p:nth-child(2){line-height: 50px}
</style>
